import { Dialog } from "primereact/dialog";
import { useDispatch } from 'react-redux';

import Attachment from "./Attachment";

import downloadFile from "../utils/DownloadFile";
import { raiseToast } from "../services/redux/reducers/toast/toast";

import DocumentView from "./DocumentView";


const FileViewModal = (props) => {
    const { visible, document, handleOnHide, docName } = props

    const dispatch = useDispatch()

    const handleDownloadPDF = (pdfURL) => {
        if (pdfURL) {
            downloadFile(pdfURL, docName ? docName : '')
        }
        else {
            dispatch(raiseToast({ severity: 'error', detail: 'PDF was not found' }))
        }
    }

    const renderFile = (document) => {
        if (typeof document === "string") {
            const ext = document.split('.').pop().toLowerCase()
            if ( ext === 'pdf' || ['png', 'jpeg', 'jpg', 'webp', 'bmp', 'gif'].includes(ext)) {
                return <DocumentView fileUrl={document} showZoomControl={true} />
            } else {
                return <Attachment url={document} displayFileName={true}/>
            }
        }
        return null
    }

    return (
        <Dialog visible={visible} className="file-view-dialog" style={{ width: '48vw', height: '95vh', backgroundColor: '#f8f8f8', textAlign: 'center'  }} onHide={handleOnHide}>
            {renderFile(document)}
        </Dialog>
    )
}

export default FileViewModal